import { useEffect, useState } from 'react';
import { Block, Done, Add } from '@mui/icons-material';
import { Tooltip, Icon } from '@mui/material';
import { BackOfficeDeliveryIconConfig } from 'types';

export interface DeviceBackOfficeDeliveryIconProps {
    iconConfig: BackOfficeDeliveryIconConfig;
}

export const DeviceBackOfficeDeliveryIcon = ({
    iconConfig,
}: DeviceBackOfficeDeliveryIconProps) => {
    const [iconElem, setIconElem] = useState<JSX.Element>(<div />);

    useEffect(() => {
        if (iconConfig) {
            setMuiIcon(iconConfig.delivery_icon);
        }
    }, [iconConfig]);

    const setMuiIcon = (icon: string) => {
        if (icon === 'done') setIconElem(<Done data-testid="DoneIcon" />);
        else if (icon === 'block')
            setIconElem(<Block data-testid="BlockIcon" />);
        else if (icon === 'add') setIconElem(<Add data-testid="AddIcon" />);
        else setIconElem(<div />);
    };

    return (
        <Tooltip
            title={iconConfig.bo_delivery_msg}
            data-testid="DeviceBackOfficeDeliveryIcon"
        >
            <Icon
                sx={{
                    color: iconConfig.color,
                    paddingRight: '5px',
                    paddingBottom: '5px',
                }}
            >
                {iconElem}
            </Icon>
        </Tooltip>
    );
};
